import React from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {Radio} from "@pg-design/radio-v2-module";
import {FormProviderRHF, TextareaField, useFormRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {otherOption} from "../../../constants/otherOption";

interface IProps {
    title: string;
    text?: string;
    options: {
        value: string;
        label: string;
    }[];
    allowOwnAnswer?: boolean;
    ownAnswerLabel?: string;
    bottomSlot?: React.ReactNode;
    submitButtonText?: string;
    onSubmit: (values: {selectedAnswer: string; ownAnswer?: string}) => Promise<void> | void;
}

interface IFormData {
    selectedAnswer: string;
    ownAnswer: string;
}

const emptyInitialValues = {
    selectedAnswer: "",
    ownAnswer: ""
};

const validationSchema = Yup.object().shape({
    selectedAnswer: Yup.string(),
    ownAnswer: Yup.string().when("selectedAnswer", {
        is: otherOption.value,
        then: (schema) => schema.min(3, "Odpowiedź musi mieć co najmniej 3 znaki").max(250, "Odpowiedź może mieć maksymalnie 250 znaków"),
        otherwise: (schema) => schema.notRequired()
    })
});

export const ModalRadioSurveyLayout = (props: IProps) => {
    const {bottomSlot, title, text, options, allowOwnAnswer, ownAnswerLabel} = props;

    const radioOptions = [
        ...options.map((option) => ({
            value: option.value,
            label: option.label
        })),
        ...(allowOwnAnswer
            ? [
                  {
                      value: otherOption.value,
                      label: ownAnswerLabel ?? otherOption.label
                  }
              ]
            : [])
    ];

    const form = useFormRHF<IFormData>({
        defaultValues: emptyInitialValues,
        resolver: yupResolver(validationSchema)
    });

    const selectedAnswer = form.watch("selectedAnswer");
    const isOtherSelected = selectedAnswer === otherOption.value;

    const onSubmit = async (values: IFormData) => {
        const {selectedAnswer, ownAnswer} = values;

        await props.onSubmit({
            selectedAnswer,
            ...(selectedAnswer === otherOption.value ? {ownAnswer} : {})
        });
    };

    return (
        <div className={innerWrapStyle}>
            <Text variant="headline_3" className={titleStyle}>
                {title}
            </Text>

            {text ? (
                <Text as="div" variant="body_copy_2" className={textStyle}>
                    {text}
                </Text>
            ) : null}

            <FormProviderRHF {...form}>
                <form className={formStyle} onSubmit={form.handleSubmit(onSubmit)}>
                    <div className={optionsWrapperStyle}>
                        <Radio
                            name="selectedAnswer"
                            options={radioOptions}
                            value={selectedAnswer}
                            onChange={(_, value) => {
                                form.setValue("selectedAnswer", value as string);

                                // Clear own answer when switching away from "OTHER"
                                if (value !== otherOption.value) {
                                    form.setValue("ownAnswer", "");
                                }
                            }}
                            className={radioWrapperStyle}
                            optionClassName={optionWrapperStyle}
                        />

                        {isOtherSelected && (
                            <div className={ownAnswerWrapperStyle}>
                                <TextareaField name="ownAnswer" autoFocus placeholder="Wpisz swoją odpowiedź..." />
                            </div>
                        )}
                    </div>

                    {form.formState.errors.selectedAnswer && (
                        <Text variant="body_copy_2" className={errorTextMainStyle}>
                            {form.formState.errors.selectedAnswer.message}
                        </Text>
                    )}

                    <div className={buttonWrapperStyle}>
                        <Button variant="filled_primary" className={buttonStyle} disabled={form.formState.isSubmitting}>
                            {props.submitButtonText ?? "Zapisz"}
                        </Button>
                    </div>
                </form>
            </FormProviderRHF>
            {bottomSlot}
        </div>
    );
};

const innerWrapStyle = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "7rem 1.5rem 1rem 1.5rem",
    md: {
        width: "65rem",
        height: "auto",
        padding: "4rem 4rem 1rem",
        borderRadius: 1
    }
});

const titleStyle = css({
    textAlign: "center",
    marginBottom: 3,
    md: {
        textAlign: "left",
        marginBottom: 1
    }
});

const textStyle = css({
    textAlign: "center",
    color: "var(--colors-gray-700)",
    md: {
        textAlign: "left"
    }
});

const formStyle = css({
    marginBottom: "4rem"
});

const optionsWrapperStyle = css({
    marginTop: "4rem"
});

const radioWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 1,
    width: "100%"
});

const optionWrapperStyle = css({
    background: "var(--colors-gray-100)",
    borderRadius: 1,
    p: 1.5,
    width: "100%"
});

const ownAnswerWrapperStyle = css({
    marginTop: 1.5
});

const errorTextMainStyle = css({
    color: "var(--colors-danger)",
    marginTop: 1.5,
    textAlign: "left"
});

const buttonWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4rem"
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto",
        minWidth: "23rem"
    }
});
import React from "react";
import {yupResolver} from "@hookform/resolvers/yup";
import {css} from "@panda/css";
import * as Yup from "yup";

import {Button} from "@pg-design/button-module";
import {Radio} from "@pg-design/radio-v2-module";
import {FormProviderRHF, TextareaField, useFormRHF} from "@pg-design/rhf-components-module";
import {Text} from "@pg-design/text-module";

import {otherOption} from "../../../constants/otherOption";

interface IProps {
    title: string;
    text?: string;
    options: {
        value: string;
        label: string;
    }[];
    allowOwnAnswer?: boolean;
    ownAnswerLabel?: string;
    bottomSlot?: React.ReactNode;
    submitButtonText?: string;
    onSubmit: (values: {selectedAnswer: string; ownAnswer?: string}) => Promise<void> | void;
}

interface IFormData {
    selectedAnswer: string;
    ownAnswer: string;
}

const emptyInitialValues = {
    selectedAnswer: "",
    ownAnswer: ""
};

const validationSchema = Yup.object().shape({
    selectedAnswer: Yup.string(),
    ownAnswer: Yup.string().when("selectedAnswer", {
        is: otherOption.value,
        then: (schema) => schema.min(3, "Odpowiedź musi mieć co najmniej 3 znaki").max(250, "Odpowiedź może mieć maksymalnie 250 znaków"),
        otherwise: (schema) => schema.notRequired()
    })
});

export const ModalRadioSurveyLayout = (props: IProps) => {
    const {bottomSlot, title, text, options, allowOwnAnswer, ownAnswerLabel} = props;

    const radioOptions = [
        ...options.map((option) => ({
            value: option.value,
            label: option.label
        })),
        ...(allowOwnAnswer
            ? [
                  {
                      value: otherOption.value,
                      label: ownAnswerLabel ?? otherOption.label
                  }
              ]
            : [])
    ];

    const form = useFormRHF<IFormData>({
        defaultValues: emptyInitialValues,
        resolver: yupResolver(validationSchema)
    });

    const selectedAnswer = form.watch("selectedAnswer");
    const isOtherSelected = selectedAnswer === otherOption.value;

    const onSubmit = async (values: IFormData) => {
        const {selectedAnswer, ownAnswer} = values;

        await props.onSubmit({
            selectedAnswer,
            ...(selectedAnswer === otherOption.value ? {ownAnswer} : {})
        });
    };

    return (
        <div className={innerWrapStyle}>
            <Text variant="headline_3" className={titleStyle}>
                {title}
            </Text>

            {text ? (
                <Text as="div" variant="body_copy_2" className={textStyle}>
                    {text}
                </Text>
            ) : null}

            <FormProviderRHF {...form}>
                <form className={formStyle} onSubmit={form.handleSubmit(onSubmit)}>
                    <div className={optionsWrapperStyle}>
                        <Radio
                            name="selectedAnswer"
                            options={radioOptions}
                            value={selectedAnswer}
                            onChange={(_, value) => {
                                form.setValue("selectedAnswer", value as string);

                                // Clear own answer when switching away from "OTHER"
                                if (value !== otherOption.value) {
                                    form.setValue("ownAnswer", "");
                                }
                            }}
                            className={radioWrapperStyle}
                            optionClassName={optionWrapperStyle}
                        />

                        {isOtherSelected && (
                            <div className={ownAnswerWrapperStyle}>
                                <TextareaField name="ownAnswer" autoFocus placeholder="Wpisz swoją odpowiedź..." />
                            </div>
                        )}
                    </div>

                    {form.formState.errors.selectedAnswer && (
                        <Text variant="body_copy_2" className={errorTextMainStyle}>
                            {form.formState.errors.selectedAnswer.message}
                        </Text>
                    )}

                    <div className={buttonWrapperStyle}>
                        <Button variant="filled_primary" className={buttonStyle} disabled={form.formState.isSubmitting}>
                            {props.submitButtonText ?? "Zapisz"}
                        </Button>
                    </div>
                </form>
            </FormProviderRHF>
            {bottomSlot}
        </div>
    );
};

const innerWrapStyle = css({
    position: "relative",
    maxHeight: "100vh",
    height: "100%",
    maxWidth: "100vw",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    padding: "7rem 1.5rem 1rem 1.5rem",
    md: {
        width: "65rem",
        height: "auto",
        padding: "4rem 4rem 1rem",
        borderRadius: 1
    }
});

const titleStyle = css({
    textAlign: "center",
    marginBottom: 3,
    md: {
        textAlign: "left",
        marginBottom: 1
    }
});

const textStyle = css({
    textAlign: "center",
    color: "var(--colors-gray-700)",
    md: {
        textAlign: "left"
    }
});

const formStyle = css({
    marginBottom: "4rem"
});

const optionsWrapperStyle = css({
    marginTop: "4rem"
});

const radioWrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 1,
    width: "100%"
});

const optionWrapperStyle = css({
    background: "var(--colors-gray-100)",
    borderRadius: 1,
    p: 1.5,
    width: "100%"
});

const ownAnswerWrapperStyle = css({
    marginTop: 1.5
});

const errorTextMainStyle = css({
    color: "var(--colors-danger)",
    marginTop: 1.5,
    textAlign: "left"
});

const buttonWrapperStyle = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "4rem"
});

const buttonStyle = css({
    width: "100%",
    md: {
        width: "auto",
        minWidth: "23rem"
    }
});
